module.exports = __webpack_public_path__ + "static/assets/b4b346262e6b2e7bd239098a4987eb7c.gif";